/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.24",
    versionName: "0.2.0-nightly.2025.8.24",
    versionChannel: "nightly",
    buildDate: "2025-08-24T00:07:48.812Z",
    commitHash: "ed3e9337328aa7ef768253b5ed9f511a5c3ffc0d",
};
